{
  "version": 1,
  "asset_id": "d50c3d1d-02b1-4e47-bd6e-8e7b2b5049e4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d50c3d1d-02b1-4e47-bd6e-8e7b2b5049e4/hiatal-type-2-story-preparation-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d50c3d1d-02b1-4e47-bd6e-8e7b2b5049e4/hiatal-type-2-story-preparation-es-800.webp",
  "original_filename": "hiatal-type-2-story-preparation-es-800.webp",
  "size": 42798,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:08Z"
}
